<template>
  <div class="faq-component" :id="faq.order">
    <div class="faq-component-header" @click="toggleIsCollapsed">
      <div class="faq-component-header-question">
        <h5 class="form-field-header">{{ faq.question }}</h5>
      </div>
      <div class="faq-component-header-icon">
        <font-awesome-icon
          v-if="isCollapsed"
          class="arrow"
          :icon="['fa', 'chevron-down']"
          :style="{ fontSize: '1rem' }"
        />
        <font-awesome-icon
          v-else
          class="arrow"
          :icon="['fa', 'chevron-up']"
          :style="{ fontSize: '1rem' }"
        />
      </div>
    </div>

    <div v-if="!isCollapsed" class="paragraph-container">
      <span v-html="content"></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getVariableReplacement } from '@/services/organizationCustomVariables'
import { currencyFormat, formatValue } from '@/services/utils'
import '@/services/utils'
export default {
  name: 'FAQComponent',
  data() {
    return {
      isCollapsed: true,
    }
  },
  props: {
    faq: {
      type: Object,
      default: null,
    },
  },
  methods: {
    toggleIsCollapsed() {
      this.isCollapsed = !this.isCollapsed
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails']),

    content() {
      const varMap = { org: this.organizationDetails }
      return formatValue(this.faq.answer.answerHtml, varMap)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.faq-component {
  width: 100%;
}

.faq-component-header {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.faq-component-header-question {
  margin-right: 2rem;

  .form-field-header {
    margin-bottom: 0;
  }
}

.question-container {
  width: 100%;
  padding: 1rem;
  background: var(--light-brand-color);
  box-shadow: 0 4px 8px 0 $mid-gray;
  border-radius: 1rem;
  margin-bottom: 1.2rem;
  margin-top: 1.2rem;

  & > h5 {
    margin: 0;
  }
}

.paragraph-container {
  width: 100%;
  margin: 0 auto;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid #dfdfe0;

  ::v-deep {
    p {
      margin-bottom: 0;
    }

    ul {
      list-style: disc;
    }

    ul > li {
      padding-left: rem;
      margin-left: 0;
    }

    ul > li::marker {
      color: black;
      font-size: 0.75rem;
    }
  }
}
</style>
